module.exports = __webpack_public_path__ + "static/img/check.f71cd9b2.svg";